import { Component, EventEmitter, Input, Output } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StandardItemModel, StandardResponseModel, StatusResponseModel } from 'src/app/api-providers/models/basic.model';
import { MasterStatsModel } from 'src/app/api-providers/models/dashboard.model';
import { FeedbackFilterModel, FeedbackModel, FeedbackResponseModel, FeedbackTemplateData } from 'src/app/api-providers/models/feedback.model';
import { UserResponseModel } from 'src/app/api-providers/models/user.model';
import { PageBreadcrumbService } from '../page-breadcrumb/page-breadcrumb.service';
import { FeedbackViewModel } from 'src/app/api-providers/view-models/feedback.view.model';
import { Router } from '@angular/router';
import { SocialUser } from '@abacritt/angularx-social-login';
import { AppCommon } from 'src/app/api-providers/app-common';

@Component({
  selector: 'app-feedback-list',
  templateUrl: './feedback-list.component.html',
  styleUrls: ['./feedback-list.component.scss']
})
export class FeedbackListComponent {

  @Input() myFeedbackPage: boolean;
  @Input() feedbackLoad  = new BehaviorSubject(false);
  @Input() dashOptionFilter= new BehaviorSubject('');
  @Output() feedbackStateUpdate : EventEmitter<any> = new EventEmitter()
  googleUser: SocialUser;
  breadcrumbMenuList = [
    // {id: 1, name: 'Dashboard', url: '/dashboard', is_active: false},
    {id: 2, name: 'Feedback', url: '/feedback', is_active: true}
  ]
  submittedBy:any
  assignedTo:any
  applicationFilter:any
  loggedInUser: any;
  isLoading: boolean = false;
  userList= []
  userListFilter = []
  applicationList = []
  applicationListFilter = []
  typeListFilter= []
  feedbackStatus = []
  searchFiltervisible = false;
  typingTimer;                //timer identifier
  doneTypingInterval = 600;  //time in ms, 5 second for exampl
  feedbackDrawerComponent: boolean = false;
  statusList = []
  applications = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  statuses = new BehaviorSubject<StatusResponseModel>(new StatusResponseModel());
  feedbackResponseModel = new BehaviorSubject<FeedbackResponseModel>(new FeedbackResponseModel());
  userResponseModel = new BehaviorSubject<UserResponseModel>(new UserResponseModel());
  feedbackTypeResponseModel = new BehaviorSubject<StandardResponseModel>(new StandardResponseModel());
  feedbackListData: FeedbackModel[] ;
  pageNo:number = 1
  feedbacktype: [StandardItemModel];
  FeedbackFilterModel = new FeedbackFilterModel();
  showFeedbackStats = [
                        {id:1,name:'Task'},
                        {id:2,name:'In-progress'},
                        {id:3,name:'Planned'},
                        {id:4,name:'Completed'},
                        {id:5,name:'Unassigned'},
                        {id:6,name:'Rejected'},
                      ]
  selectedStats = [1,2,3,4]
 
  constructor(
    private breadcrumbService: PageBreadcrumbService,
    private vm: FeedbackViewModel,
    private router: Router,
  ) {
    this.breadcrumbService.updateList(this.breadcrumbMenuList)
    this.loggedInUser = AppCommon.getloggedInObject().user;
    }


  ngOnInit(): void {
    this.vm.parentFeedbackListComponent = this;
    this.vm.subscribeToFeedbacksList(
      this.applications,
      this.statuses,
      this.feedbackResponseModel,
      this.userResponseModel,
      this.feedbackTypeResponseModel
    );

    this.vm.getApplications('feedback-list');
    this.vm.getUsers('feedback-list');
    this.vm.getFeedbackType('feedback-list');
    // this.getFeedbacks();
    this.vm.getStatuses('feedback-list')
    this.vm.getFeedbackStatuses('feedback-list')
    
    this.dashOptionFilter.subscribe( e =>  {
   
      if(e == "Unassigned" || e =="Rejected"){
        this.FeedbackFilterModel.status=this.feedbackStatus?.filter(f => f.name == e)[0]?.id
        this.FeedbackFilterModel.f_task = false
      }else{
        this.FeedbackFilterModel.f_task = true
        this.FeedbackFilterModel.status = this.statusList?.filter(f => f.name == e)[0]?.id
      }
      this.pageNo = 1
      this.getFeedbacks()
    })
    this.feedbackLoad.subscribe( e => {
      if(e){
        this.pageNo = 1
        this.getFeedbacks()
      }
    })
  }

  statusesReceived(){
    this.statusList = this.statuses.value.results;
    // this.statuses.value.results.forEach((e)=> {
    //   this.statusList.push({text:e.name,value:e.id}) 
    // } )
  }


  


  showStats(id){
    return this.selectedStats.includes(id)
  }

  resetFeedbackModal(){
    this.pageNo = 1
    for(const key in this.FeedbackFilterModel){
      if(  this.FeedbackFilterModel[key]  === true ){
        this.FeedbackFilterModel[key] = undefined
      }  
    }
  }

  sort(event){
    // this.FeedbackFilterModel = new FeedbackFilterModel();
  
    const sortData:{key:'' ,value:''} = event.sort.filter(e => e.value !== null )[0]
    
    this.resetFeedbackModal()
    if(event.sort.length > 0 && sortData?.value != null){
      const {key  , value } = sortData || {};
      this.FeedbackFilterModel[key] = true
      this.FeedbackFilterModel[value]  = true
    }
    if(event.filter.map(e => e.value).some(e => e.length > 0) || event.sort.map(e => e.value).some(e => e !== null)){
      // console.log(!event.sort.map(e => e.value).every(e => e == null))
      this.pageNo = 1
      this.getFeedbacks()
    }  
     
    
  }

  addFeedback(){
    this.feedbackDrawerComponent = true;
  }

  getFeedbacks(){
    if(this.myFeedbackPage){
      this.FeedbackFilterModel.submitted_by = this.loggedInUser.id
    }
    
    this.isLoading = true;
    this.vm.getFeedbacks(this.pageNo, this.FeedbackFilterModel, 'feedback-list');
    
  }

  filterFn = (list: string[], item: any): boolean => list.some(name => item.name.indexOf(name) !== -1);

  usersReceived(){
    this.userList =  this.userResponseModel.value.results
    this.userListFilter = []
    this.userList.forEach((e)=> {
      this.userListFilter.push({text:e.user_name,value:e.id}) 
    } )

  }

  inputkeyUp() {
    clearTimeout(this.typingTimer);
    this.typingTimer = setTimeout(this.getFeedbacks.bind(this), this.doneTypingInterval);
  };

  //on keydown, clear the countdown
  inputKeyDown() {
    clearTimeout(this.typingTimer);
  };

  feedBackTypeReceived(){
    this.feedbacktype =  this.feedbackTypeResponseModel.value.results
    this.typeListFilter = []
    this.feedbacktype.forEach( e => this.typeListFilter.push({text:e.name,value:e.id}));
  }



  feedbackStatusRecieved(e){
    this.feedbackStatus = e.results
  }
  
  applicationReceived(){
    this.applicationListFilter = []
    this.applicationList = this.applications.value.results
    this.applicationList.forEach(e => this.applicationListFilter.push({text:e.name,value:e.id}))
 
  }

  filterFeedback(e,field){
    // this.FeedbackFilterModel = new FeedbackFilterModel();
    if(e.length == 0){
      this.pageNo = 1
      this.FeedbackFilterModel[field] = undefined
      this.feedbackStateUpdate.emit(JSON.parse(JSON.stringify(this.FeedbackFilterModel)))
      setTimeout(() =>  this.getFeedbacks() , 10) 
    } else{
      this.FeedbackFilterModel[field] = e
      
    }
    
  }


  filterFeedbackSearch(e,field){
    // this.FeedbackFilterModel = new FeedbackFilterModel();
    if(e){
      this.pageNo = 1
      this.FeedbackFilterModel[field] = e
      this.feedbackStateUpdate.emit(JSON.parse(JSON.stringify(this.FeedbackFilterModel)))
      setTimeout(() =>  this.getFeedbacks() , 10) 
    } else{
      this.FeedbackFilterModel[field] = undefined
      setTimeout(() =>  this.getFeedbacks() , 10)
      this.feedbackStateUpdate.emit(JSON.parse(JSON.stringify(this.FeedbackFilterModel)))
    }
    
  }
   
  getFeedBackType(id:number){
    if(this.feedbacktype && this.feedbacktype.length > 0 && id !== null){
      return  this.feedbacktype.filter(e => e.id == id)[0]?.name
    } else{
      return 'NA'
    }
   
  }

  getAppName(id:number){
    if(this.applicationList && this.applicationList.length > 0 && id !== null){
      return  this.applicationList.filter(e => e.id == id)[0]?.name
    } else{
      return 'NA'
    }
   
  }

  getUserName(id:number){
    if(this.userList.length > 0 && id !== null){
      return  this.userList.filter(e => e.id == id)[0]?.user_name
    } else{
      return 'NA'
    }

  }

  getFeedbackAssignedUserId(data: FeedbackModel){
    return data?.assigned_user?.[0]?.id || null;
  }

  goToDetail(item: any){
    var url = '';
    if(this.myFeedbackPage) {
      url += 'my-feedback/' + String(item);
    } else {
      url += 'feedback/' + String(item);
    }
    // this.router.navigate([url]);
    window.open(url,'_blank')
  }


  receiveCloseMessage(e: any){
    this.feedbackDrawerComponent = e;
  }

  
  updateTemplateData(data: FeedbackModel[]){

    var magicData = data;

    for(var i = 0; i < magicData.length; i++){ 
      magicData[i].template_data = new FeedbackTemplateData();

                // Update status
                if(magicData[i].status.task == false){
                  magicData[i].template_data.status_name = magicData[i].status.name;
                  magicData[i].template_data.status_color = magicData[i].status.name === 'Rejected' ? '#ff2600':'grey';
                } else {
                  var status = this.statuses.value.results.find(el => el.id == magicData[i].status.id)
                  if(status){
                    magicData[i].template_data.status_name = status.name;
                    magicData[i].template_data.status_color = status.hexcolor; 
                  }
                }
                
                if(magicData[i].assigned_user){
                  magicData[i].template_data.assigned_user_name = magicData[i].assigned_user.map(e => e.name).join(',') 
                }
    }
    return data
  }

  feedbackReceived(){

    if(this.pageNo == 1){
      this.feedbackListData = this.feedbackResponseModel.value.results;
      this.isLoading = false;
    } else if (this.pageNo > 1){
      this.feedbackListData.push(...this.feedbackResponseModel.value.results);
      this.isLoading = false;
    }
  
    this.feedbackListData = this.updateTemplateData(this.feedbackListData);
  }

  onScroll(e) {
    // 
    if(this.feedbackResponseModel.value.next !== null){
      this.pageNo += 1
      this.getFeedbacks();
      this.isLoading = true;
    }

  }
  
}
